import React from "react";
import DashboardMainContent from "../Components/Dashboard/Admin/DashboardMainContent";

function Dashboard() {
    return <DashboardMainContent />;
}

export default Dashboard;
